var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWfClone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 799.465,
    height: 552.326,
    viewBox: "0 0 799.465 552.326",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560.267 -263.837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1352.3,232.384H580.059a13.747,13.747,0,0,0-13.613,13.848v524.66a13.74,13.74,0,0,0,13.613,13.819H1352.3a13.741,13.741,0,0,0,13.613-13.819V246.232a13.747,13.747,0,0,0-13.611-13.848Z",
    transform: "translate(-6.18 31.452)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.244,232.384h-748.6a13.225,13.225,0,0,0-13.2,13.223V746.614a13.219,13.219,0,0,0,13.2,13.2h748.6a13.219,13.219,0,0,0,13.2-13.2V245.608a13.224,13.224,0,0,0-13.194-13.223Z",
    transform: "translate(-4.945 34.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.305 -65)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.209,
    cy: 42.209,
    rx: 42.209,
    ry: 42.209,
    transform: "translate(658.469 384.59)",
    fill: "#c40404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8-54.353v-4.379a14.411,14.411,0,0,1-8.782-3.137A10.2,10.2,0,0,1,5.566-69.6H11.8a5.148,5.148,0,0,0,1.87,3.811,7.911,7.911,0,0,0,4.142,1.637V-74.616l-1.9-.5a15.7,15.7,0,0,1-6.9-3.43,7.85,7.85,0,0,1-2.473-6.036A9.128,9.128,0,0,1,7.993-89.7a10.606,10.606,0,0,1,4-3.573A15.06,15.06,0,0,1,17.8-94.906V-99.38h2.84v4.451a14.55,14.55,0,0,1,5.977,1.562,10.585,10.585,0,0,1,3.989,3.551,9.314,9.314,0,0,1,1.515,4.971H25.994a4.679,4.679,0,0,0-1.637-3.2,6.9,6.9,0,0,0-3.717-1.491v9.871l1.586.4a23.581,23.581,0,0,1,4.983,1.835,10.824,10.824,0,0,1,3.885,3.211,8.271,8.271,0,0,1,1.5,5.09,9.313,9.313,0,0,1-3.137,7.22q-3.137,2.84-8.818,3.172v4.379Zm2.84-9.82a7.418,7.418,0,0,0,4.084-1.657,4.251,4.251,0,0,0,1.551-3.338,3.357,3.357,0,0,0-1.539-2.971,13.86,13.86,0,0,0-4.092-1.716ZM17.8-80.392v-9.113a6.361,6.361,0,0,0-3.586,1.562,3.97,3.97,0,0,0-1.29,2.982,3.381,3.381,0,0,0,1.5,2.971,12.2,12.2,0,0,0,3.376,1.6Z",
    transform: "translate(681.598 503.664)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 308,
    height: 46,
    rx: 6,
    transform: "translate(813.305 339)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.391,355.938l-17.978-21.862a5.3,5.3,0,0,0-8.072-.134L506.115,355.8a5.3,5.3,0,0,0,7.959,7l9.947-11.311v28.363a5.3,5.3,0,0,0,10.6,0V352.229l8.586,10.441a5.3,5.3,0,0,0,8.186-6.732Z",
    transform: "translate(647.623 3.352)",
    fill: "#c40404"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(697.773 484.014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.44,473.526H235.29a9.111,9.111,0,0,1-9.1-9.1V436.648a9.111,9.111,0,0,1,9.1-9.1H493.44a9.111,9.111,0,0,1,9.1,9.1v27.779a9.111,9.111,0,0,1-9.1,9.1ZM235.29,428.5a8.151,8.151,0,0,0-8.142,8.142v27.779a8.151,8.151,0,0,0,8.142,8.142H493.44a8.151,8.151,0,0,0,8.142-8.142V436.648a8.151,8.151,0,0,0-8.142-8.144Z",
    transform: "translate(-226.19 -427.548)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.616,472.332a15.839,15.839,0,1,1,15.839-15.839,15.839,15.839,0,0,1-15.839,15.839Z",
    transform: "translate(-249.633 -433.504)",
    fill: "#c40404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.174,487.007H360.108a3.832,3.832,0,1,1,0-7.663H529.174a3.832,3.832,0,1,1,0,7.664Z",
    transform: "translate(-285.308 -451.086)",
    fill: "#c40404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.089,457.158H360.1a3.832,3.832,0,1,1,0-7.664H474.089a3.832,3.832,0,1,1,0,7.663Z",
    transform: "translate(-285.305 -437.521)",
    fill: "#c40404"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(697.773 562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.44,473.526H235.29a9.111,9.111,0,0,1-9.1-9.1V436.648a9.111,9.111,0,0,1,9.1-9.1H493.44a9.111,9.111,0,0,1,9.1,9.1v27.779a9.111,9.111,0,0,1-9.1,9.1ZM235.29,428.5a8.151,8.151,0,0,0-8.142,8.142v27.779a8.151,8.151,0,0,0,8.142,8.142H493.44a8.151,8.151,0,0,0,8.142-8.142V436.648a8.151,8.151,0,0,0-8.142-8.144Z",
    transform: "translate(-226.19 -427.548)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.616,472.332a15.839,15.839,0,1,1,15.839-15.839,15.839,15.839,0,0,1-15.839,15.839Z",
    transform: "translate(-249.633 -433.504)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.174,487.007H360.108a3.832,3.832,0,1,1,0-7.663H529.174a3.832,3.832,0,1,1,0,7.664Z",
    transform: "translate(-285.308 -451.086)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.089,457.158H360.1a3.832,3.832,0,1,1,0-7.664H474.089a3.832,3.832,0,1,1,0,7.663Z",
    transform: "translate(-285.305 -437.521)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(697.773 639.986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.44,473.526H235.29a9.111,9.111,0,0,1-9.1-9.1V436.648a9.111,9.111,0,0,1,9.1-9.1H493.44a9.111,9.111,0,0,1,9.1,9.1v27.779a9.111,9.111,0,0,1-9.1,9.1ZM235.29,428.5a8.151,8.151,0,0,0-8.142,8.142v27.779a8.151,8.151,0,0,0,8.142,8.142H493.44a8.151,8.151,0,0,0,8.142-8.142V436.648a8.151,8.151,0,0,0-8.142-8.144Z",
    transform: "translate(-226.19 -427.548)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.616,472.332a15.839,15.839,0,1,1,15.839-15.839,15.839,15.839,0,0,1-15.839,15.839Z",
    transform: "translate(-249.633 -433.504)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.174,487.007H360.108a3.832,3.832,0,1,1,0-7.663H529.174a3.832,3.832,0,1,1,0,7.664Z",
    transform: "translate(-285.308 -451.086)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.089,457.158H360.1a3.832,3.832,0,1,1,0-7.664H474.089a3.832,3.832,0,1,1,0,7.663Z",
    transform: "translate(-285.305 -437.521)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271.576,431.763H252.2a1.982,1.982,0,0,1-1.98-1.979v-63.86a1.982,1.982,0,0,1,1.98-1.979h19.381a1.982,1.982,0,0,1,1.98,1.979v63.86A1.982,1.982,0,0,1,271.576,431.763Z",
    transform: "translate(785.289 254.201)",
    fill: "#c40404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.814,375.915H365.433a1.982,1.982,0,0,1-1.98-1.979v-89.2a1.982,1.982,0,0,1,1.98-1.979h19.381a1.982,1.982,0,0,1,1.98,1.979v89.2A1.982,1.982,0,0,1,384.814,375.915Z",
    transform: "translate(707.395 310.049)",
    fill: "#c40404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.051,431.763H478.67a1.982,1.982,0,0,1-1.98-1.979v-63.86a1.982,1.982,0,0,1,1.98-1.979h19.381a1.982,1.982,0,0,1,1.98,1.979v63.86A1.982,1.982,0,0,1,498.051,431.763Z",
    transform: "translate(629.502 254.201)",
    fill: "#c40404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.289,353.869H591.908a1.938,1.938,0,0,1-1.98-1.89V252.6a1.939,1.939,0,0,1,1.98-1.89h19.381a1.938,1.938,0,0,1,1.98,1.89v99.383A1.938,1.938,0,0,1,611.289,353.869Z",
    transform: "translate(551.609 332.096)",
    fill: "#c40404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.526,314.188H705.145a1.982,1.982,0,0,1-1.98-1.979V195a1.982,1.982,0,0,1,1.98-1.979h19.381a1.982,1.982,0,0,1,1.98,1.979V312.209A1.982,1.982,0,0,1,724.526,314.188Z",
    transform: "translate(473.715 371.776)",
    fill: "#c40404"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWfClone);
export default __webpack_public_path__ + "static/media/wf-clone.5bed3d0a1e33fb80983ed97c1f8f8eb3.svg";
export { ForwardRef as ReactComponent };